import React from "react";
import Util from "classes/Util";
import "./styles.css";

/**
 * @function LoginWrapper
 * @returns {React.Component}
 * @exported true
 * @description The is the iframe wrapper that will pull in, specifically, MABI23 pages and does not have a BottomNavView.
 */
export default function LoginWrapper(props) {
  // START: Sets abi22 custom font only in the mabi23 login page.
  const branding = Util.getABI22Branding();
  const options = branding ? branding.options : {};
  let className = props.className ?? "";
  const customFont = options.custom_font_abi22;
  let customFontClass = "";
  const hasCustomFont = (customFont === "undefined" || customFont === "Default" || customFont === undefined) ? false : true;

  if(hasCustomFont) {
    customFontClass = `${ customFont.toLowerCase() }-font`;
    className = `${ className } ${ customFontClass }`;
  }
  // END: Sets abi22 custom font only in the mabi23 login page.

  return (
    <div className={ `login-wrapper ${ className }` }>
      {props.children}
    </div>
  );
}